import api from "./api";

export const getBlogs = async (params = {}) => {
  try {
    const res = await api.get("/blogs/", { params });
    return res.data;
  } catch (error) {
    console.error("Error fetching blogs:", error);
    throw error;
  }
};

export const getBlogBySlug = async (slug) => {
  try {
    const res = await api.get(`/blogs/${slug}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching blog:", error);
    throw error;
  }
};

export const createBlog = async (data) => {
  try {
    // API formatına uygun olarak veriyi düzenle
    const formattedData = {
      slug: data.title.tr.toLowerCase()
        .replace(/ı/g, 'i')
        .replace(/ğ/g, 'g')
        .replace(/ü/g, 'u')
        .replace(/ş/g, 's')
        .replace(/ö/g, 'o')
        .replace(/ç/g, 'c')
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, ''),
      title: data.title,
      content: data.content,
      tags: data.tags || [],
      author: data.author || 'Admin',
      status: data.status || 'draft',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    
    console.log("Sending blog data:", formattedData);
    const res = await api.post("/blogs/", formattedData);
    return res.data;
  } catch (error) {
    console.error("Error creating blog:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
    }
    throw error;
  }
};

export const updateBlog = async (id, data) => {
  try {
    // API formatına uygun olarak veriyi düzenle
    const formattedData = {
      slug: data.title.tr.toLowerCase()
        .replace(/ı/g, 'i')
        .replace(/ğ/g, 'g')
        .replace(/ü/g, 'u')
        .replace(/ş/g, 's')
        .replace(/ö/g, 'o')
        .replace(/ç/g, 'c')
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, ''),
      title: data.title,
      content: data.content,
      tags: data.tags || [],
      author: data.author || 'Admin',
      status: data.status || 'draft',
      updatedAt: new Date().toISOString()
    };
    
    console.log("Updating blog data:", formattedData);
    const res = await api.put(`/blogs/${id}`, formattedData);
    return res.data;
  } catch (error) {
    console.error("Error updating blog:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
    }
    throw error;
  }
};

export const deleteBlog = async (id) => {
  try {
    const res = await api.delete(`/blogs/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting blog:", error);
    throw error;
  }
};

export const uploadBlogImage = async (id, file) => {
  try {
    console.log("=== UPLOADING BLOG IMAGE ===");
    console.log("Blog ID:", id);
    console.log("File:", file.name, file.size, "bytes", file.type);
    
    const formData = new FormData();
    formData.append("image", file);
    
    console.log("Making request to:", `/blogs/${id}/image`);
    const res = await api.post(`/blogs/${id}/image`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    console.log("Upload successful:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR UPLOADING BLOG IMAGE ===");
    console.error("Error:", error.message);
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
    }
    throw error;
  }
};
